import { Component, computed, input, InputSignal, output, Pipe, PipeTransform, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Content, TranscriptEntry } from '../types';
import { TranscriptContentsComponent } from '../transcript-contents/transcript-contents.component';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

@Pipe({
  name: 'secondsToDateSeconds',
  standalone: true,
})
export class SecondsToDateSeconds implements PipeTransform {
  transform(seconds: number): number {
    return new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(seconds);
  }
}

@Component({
  selector: 'glxy-transcript-entry',
  standalone: true,
  imports: [CommonModule, TranscriptContentsComponent, GalaxyAvatarModule, SecondsToDateSeconds],
  templateUrl: './transcript-entry.component.html',
  styleUrls: ['./transcript-entry.component.scss'],
})
export class TranscriptEntryComponent {
  entry: InputSignal<TranscriptEntry> = input.required<TranscriptEntry>();
  readonly contentClicked = output<Content>();

  firstEntryStartTime: Signal<number> = computed(() => {
    if (this.entry()?.content?.length > 0) {
      return this.entry()?.content[0].startTime;
    }
    return 0;
  });

  hourInSeconds = 3600;

  clickedContent($event: Content): void {
    this.contentClicked.emit($event);
  }
}
